module.exports = __webpack_public_path__ + "img/unkown.0793a511.png";